import Dashboard from '../containers/dashboard'
import CustomerDetailsManagement from '../containers/customer-details-management'

const CustomersDetails = () => {
  return (
    <Dashboard>
      <CustomerDetailsManagement />
    </Dashboard>
  )
}

export default CustomersDetails
